// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------
import HubspotFormSubmissionRecord from "models/view-models/hubspot/hubspot-form-submission-record";
import { ServiceHookFactory } from "../service-hook-factory";
import HubspotFormRecord from "models/view-models/hubspot/hubspot-form-record";

export interface HubspotFormPathParams {
    formId: string;
}
export interface HubspotFormSubmitPathParams extends HubspotFormPathParams {
    portalId: number;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "external/hubspot/form";
const resourceEndpoint = `${baseEndpoint}/:formId`;
const submitEndpoint = `${baseEndpoint}/:portalId/:formId`;
const key = "hubspot-form";
const resourceType = HubspotFormRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const HubspotFormService = {
    key,
    useGetQuery: ServiceHookFactory.useGet<HubspotFormRecord, HubspotFormPathParams>(
        resourceType,
        resourceEndpoint
    ),
    useCreate: ServiceHookFactory.useNestedCreate<
        HubspotFormSubmissionRecord,
        HubspotFormSubmitPathParams
    >(HubspotFormSubmissionRecord, submitEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default HubspotFormService;

// #endregion Exports
